export default [
  {
    id: 'daily-light',
    title: 'Daily Light',
    period: '2026 봄',
    description: '평범한 하루에 남은 빛과 장면을 모은 앨범입니다.',
    coverImage: 'img/bg1.jpg',
    photos: [
      {
        id: 'daily-window',
        title: '창가의 오후',
        image: 'img/bg1.jpg',
        takenAt: '2026.04.12',
        location: 'Seoul',
        camera: 'iPhone',
        tagsText: '빛, 오후, 실내',
        memo: '창가로 들어온 빛이 책상 위에 오래 머문 날'
      },
      {
        id: 'daily-street',
        title: '걷는 길',
        image: 'img/bg3.jpg',
        takenAt: '2026.04.18',
        location: 'Hongdae',
        camera: 'Fujifilm X100V',
        tagsText: '거리, 산책, 도시',
        memo: '사람이 빠진 거리의 선과 색을 기록'
      },
      {
        id: 'daily-blue',
        title: '푸른 벽',
        image: 'img/bg4.jpg',
        takenAt: '2026.04.22',
        location: 'Mapo',
        camera: 'Sony A7C',
        tagsText: '벽, 색감, 미니멀',
        memo: '단순한 배경 안에서 색이 먼저 보였던 장면'
      }
    ]
  },
  {
    id: 'travel-notes',
    title: 'Travel Notes',
    period: '2025 겨울',
    description: '이동 중 마주친 풍경과 숙소 주변의 작은 기억들입니다.',
    coverImage: 'img/bg5.jpg',
    photos: [
      {
        id: 'travel-hill',
        title: '언덕 위 풍경',
        image: 'img/bg5.jpg',
        takenAt: '2025.12.28',
        location: 'Busan',
        camera: 'Canon EOS R8',
        tagsText: '여행, 풍경, 바다',
        memo: '멀리 보이는 바다와 낮은 건물들의 레이어'
      },
      {
        id: 'travel-room',
        title: '여행자의 방',
        image: 'img/login.jpg',
        takenAt: '2025.12.29',
        location: 'Busan',
        camera: 'iPhone',
        tagsText: '숙소, 밤, 기록',
        memo: '하루가 끝난 뒤 물건들이 놓인 상태까지 남기기'
      },
      {
        id: 'travel-market',
        title: '시장 입구',
        image: 'img/bg6.jpg',
        takenAt: '2025.12.30',
        location: 'Busan',
        camera: 'Ricoh GR III',
        tagsText: '시장, 간판, 사람',
        memo: '여행지의 리듬이 가장 크게 들리던 곳'
      }
    ]
  },
];
